// rootSaga.js
import { all } from "redux-saga/effects";
import authSaga from "./authSaga";

function* rootSaga() {
  yield all([
    authSaga(),
    // Add other sagas if you have more
  ]);
}

export default rootSaga;
